import { c as _c } from "react/compiler-runtime";
import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { getProjectsTags, getProjectsTagsFilterPresets, getTagFilterOption, parseTagFilterId } from "@components/projects/projects-filters/projects-tags-filter-utils";
import { useStreamedProjects } from "@hooks/projects/use-streamed-projects";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { selectedSdbCompanyIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useState } from "react";
/**
 * A chip to filter the projects by tags. It offers the projects without a tag and the tags of all
 * the projects, which are loaded from the projects stream when the chip is first opened. The user
 * can search the tags and apply several of them at once.
 */
export function TagsFilterChip(t0) {
  const $ = _c(20);
  const {
    filteredColumn,
    label,
    projectArchivingState,
    tableType
  } = t0;
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const companyId = useAppSelector(selectedSdbCompanyIdSelector);
  let t1;
  if ($[0] !== companyId || $[1] !== hasBeenOpened || $[2] !== projectArchivingState) {
    t1 = {
      companyId,
      projectArchivingState,
      isEnabled: hasBeenOpened
    };
    $[0] = companyId;
    $[1] = hasBeenOpened;
    $[2] = projectArchivingState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    projects,
    fetchingStatus
  } = useStreamedProjects(t1);
  const {
    getFilterIdsForColumn
  } = useFilterQueryParams();
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[4] !== filteredColumn || $[5] !== getFilterIdsForColumn || $[6] !== label || $[7] !== projects) {
    const activeFilterIds = getFilterIdsForColumn(filteredColumn);
    T0 = DropdownFilterChip;
    t2 = label;
    t3 = filteredColumn;
    t4 = getTagsFilterItems(projects, activeFilterIds);
    $[4] = filteredColumn;
    $[5] = getFilterIdsForColumn;
    $[6] = label;
    $[7] = projects;
    $[8] = T0;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    T0 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
  }
  const t5 = fetchingStatus === "uninitialized" || fetchingStatus === "pending";
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setHasBeenOpened(true);
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T0 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== tableType) {
    t7 = <T0 label={t2} filteredColumn={t3} items={t4} shouldShowSearchBox={true} shouldShowCheckbox={true} tableType={tableType} size="large" isLoading={t5} onOpen={t6} />;
    $[13] = T0;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = tableType;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}

/**
 * Returns the filter for the projects without a tag, then the tags of the projects sorted by name.
 * The applied tags are listed too, even if no project has them, e.g. from an old link, so the user
 * can remove them.
 */
function getTagsFilterItems(projects, activeFilterIds) {
  const appliedTags = activeFilterIds.flatMap(filterId => parseTagFilterId(filterId) ?? []);
  const tags = new Set([...getProjectsTags(projects), ...appliedTags]);
  const tagFilters = [...tags].sort((a, b) => a.localeCompare(b)).map(getTagFilterOption);
  return {
    ...getProjectsTagsFilterPresets(),
    ...Object.fromEntries(tagFilters.map(filter => [filter.id, filter]))
  };
}